import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { SearchResults, SearchService } from '../../services/search.service';
import { FormControl } from '@angular/forms';
import { MembersPhotoTrackingService, TrackerActions, TrackerGuestSearchObject } from 'projects/photos-app/src/app/share-components/members-photo-tracking.service';

@Component({
  selector: 'app-search-menu',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  @ViewChild('searchInput', { read: ElementRef, static: false }) private searchElement: ElementRef;
  searchStr: string = '';//FormControl = new FormControl();
  searching: boolean ;
  resultList: SearchResults[] = [];

  constructor(private searchService: SearchService, private trackSvc: MembersPhotoTrackingService) {
  }

  ngOnInit() {

  }

  // on focus call OnSearch to display result if there is something to search on input
  search() {
    this.searching = true;
    this.searchElement.nativeElement.focus();
    if (this.searchStr)
      this.searchFields(this.searchStr);
    else
      this.searching = false;
  }


  private searchFields(value: string) {
    // Check min characters threshold
    if (value && value.length > 3) {
      let request = {
        searchText: value,
        categories: []
      }
      // find all fields that match search criteria
      this.trackSvc.trackGuestSearchAction(TrackerActions.GUEST_MENU_SEARCH, new TrackerGuestSearchObject(value));
      this.searchService.searchContent(request).subscribe(res => {
        this.resultList = res;
        this.searching = false;
        console.log(this.resultList);
      })

    } else if (this.resultList.length > 0) {
      this.resultList = [];
      this.searching = false;
    }

  }

}
